import * as React from 'react';
import type { Control, FieldValues, Path } from 'react-hook-form';
import { Controller } from 'react-hook-form';

type Props<T, F> = {
	name: Path<F>;
} & T;

export const WithControl = <T, F extends FieldValues>(
	Component: React.FC<T>,
	control: Control<F, any>
): React.FC<Props<T, F>> => {
	return React.useCallback(
		(props: Props<T, F>) => (
			<Controller
				name={props.name as Path<F>}
				control={control}
				render={({ field }) => <Component {...props} {...field} />}
			/>
		),
		[control, Component]
	);
};
